module.exports = {"530328001":"西平街道","530328002":"龙华街道","530328003":"金龙街道","530328004":"花山街道","530328102":"白水镇","530328103":"盘江镇","530328201":"炎方乡","530328202":"播乐乡","530328203":"大坡乡","530328204":"菱角乡","530328205":"德泽乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530328.json
// module id = 2696
// module chunks = 0